import { Box } from '@mui/material'
import { UseFormSetValue } from 'react-hook-form'
import { FileUploader, Resource } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { CellFrame, Organism } from '@/core/architecture'

type FavoriteMemberImageUploadCellProps = {
  onDrop: () => Promise<Resource | null>
  setValue: UseFormSetValue<any>
  onDelete?: () => void
  progress: number
  defaultResource?: Resource
  fieldName: string
  translationNamespace: string
}

export const FavoriteMemberImageUploadCell: Organism<FavoriteMemberImageUploadCellProps> =
  ({
    onDrop,
    setValue,
    onDelete,
    progress,
    defaultResource,
    fieldName,
    translationNamespace,
  }) => {
    const { t } = useTranslation(translationNamespace)

    return (
      <CellFrame>
        <Box sx={{ position: 'relative' }}>
          <FileUploader
            shape="circle"
            resource={defaultResource}
            t={t}
            fileUploadInfo={{
              type: 'image',
              async onDrop() {
                const result = await onDrop()
                if (result) {
                  setValue(fieldName, result.imageUploadPath as never, {
                    shouldValidate: true,
                  })
                }
                return result || undefined
              },
              progress: progress,
              description: t('imageDescription'),
              onClose() {
                if (onDelete) {
                  onDelete()
                }
              },
            }}
            content={{
              title: t('addImage'),
            }}
          />
        </Box>
      </CellFrame>
    )
  }
